// pages/products.tsx

import ProductPageLayout from "./ProductPageLayout";

const ProductPage = () => {
  return (
    <div>
      <ProductPageLayout />
    </div>
  );
};

export default ProductPage;
